import React from "react";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import { Modal } from "@material-ui/core";
import { PrimaryCTAButton } from "../../common/Buttons";

const GuidelinesDialog = ({
  open,
  onClose,
  title = "Guidelines",
  content,
  buttonText = "Got it, thanks",
  buttonBackgroundColor,
  buttonTextColor,
}) => {
  return (
    <Modal open={open} onClose={onClose} disableRestoreFocus={true}>
      <DrawerContainer>
        <Container>
          <HeadingContainer>
            <Heading>{title}</Heading>
            <CloseModal
              onClick={onClose}
              src={require("../../../assets/images/closeModal.svg")}
            />
          </HeadingContainer>

          <ContentContainer>
            {content ? (
              <FormattedContent
                dangerouslySetInnerHTML={{ __html: formatContent(content) }}
              />
            ) : (
              <p>No guidelines available.</p>
            )}
          </ContentContainer>

          <ButtonContainer>
            <PrimaryCTAButton
              style={{
                width: "auto",
                minWidth: 180,
                background: buttonBackgroundColor,
                color: buttonTextColor || "#fff",
                border: buttonBackgroundColor
                  ? `1px solid ${buttonBackgroundColor}`
                  : undefined,
              }}
              onClick={onClose}
            >
              {buttonText}
            </PrimaryCTAButton>
          </ButtonContainer>
        </Container>
      </DrawerContainer>
    </Modal>
  );
};

export default GuidelinesDialog;

/* ====================== Smart Content Formatter ====================== */
const formatContent = (text) => {
  if (!text) return "";

  let formatted = text
    .replace(/\t/g, "  ") // Replace tabs with spaces
    .trim();

  // Split into lines
  const lines = formatted.split(/\n/);

  const htmlLines = lines.map((line) => {
    const trimmed = line.trim();

    // Skip empty lines
    if (!trimmed) return "<br/>";

    // Convert lines that look like list items into bullets
    if (
      trimmed.startsWith("- ") ||
      trimmed.startsWith("• ") ||
      trimmed.match(/^\d+\.\s/) ||
      (trimmed.length > 15 &&
        (trimmed.includes("Chrome") ||
          trimmed.includes("Browser") ||
          trimmed.includes("Internet") ||
          trimmed.includes("need") ||
          trimmed.includes("Allow")))
    ) {
      return `<li>${trimmed.replace(/^- |^• |^\d+\.\s/, "")}</li>`;
    }

    if (trimmed.endsWith(":") || trimmed.length < 60) {
      return `<strong>${trimmed}</strong><br/>`;
    }

    return `<li>${trimmed}</li>`;
  });

  return `<ul>${htmlLines.join("")}</ul>`;
};

export const DrawerContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media ${theme?.breakpoints?.sm_up} {
    max-width: 720px;
  }
`;

export const Container = styled.div`
  margin: 0 15px;
  background-color: white;
  outline: none;
  //border-radius: 12px;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);

  @media ${theme?.breakpoints?.sm_up} {
    margin: 0;
  }
`;



export const CloseModal = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
  cursor: pointer;
  position: absolute;
  right: 34px;
  top: 28px;

  @media ${theme.breakpoints.sm_up} {
    right: 40px;
  }
`;

export const HeadingContainer = styled.div`
  padding: 28px 70px 20px 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-bottom: 1px solid #f1f1f2;

  @media ${theme.breakpoints.sm_up} {
    padding: 28px 90px 20px;
  }
`;

export const Heading = styled.h3`
  margin: 0;
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontExtraBold};
  text-align: center;

  white-space: normal;
  overflow-wrap: break-word;
  word-break: normal;
  line-height: 1.4;
`;

export const ContentContainer = styled.div`
  padding: 28px 40px;
  color: ${COLORS.COLOR_DARK};
  font-size: 15.2px;
  font-family: ${theme.fonts.primaryFontRegular};
  line-height: 1.8;
  overflow-y: auto;
  flex: 1;
  background: #fafafa;
`;

export const FormattedContent = styled.div`
  ul {
    padding-left: 20px;
    margin: 0;
  }

  li {
    margin-bottom: 12px;
    padding-left: 6px;
    color: #1f2937; 
    font-weight: 500;
  }

  strong {
    font-weight: 600;
    color: #1f2937;
    display: block;
    margin: 16px 0 8px;
  }

  br {
    margin: 8px 0;
  }
`;

export const ButtonContainer = styled.div`
  padding: 24px 40px 32px;
  border-top: 1px solid #f1f1f2;
  display: flex;
  justify-content: center;
  background: white;
`;
